import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Delete-Popup.scss';
import { Button } from '@material-ui/core';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const DeletePopupModel = (props) => {
  const { deletePopUp, onDelete, showImage, onDeleteCancel } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    onDeleteCancel();
  };

  const onDeleteClick = (e) => {
    onDelete(e);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='delete-popup'>
        {showImage && (
          <div className='row d-flex justify-content-center my-3'>
            <img alt={deletePopUp.index} src={deletePopUp.image} className='img' />
          </div>
        )}
        <div className='delete-popup-title'>
          {deletePopUp.title} <br />
          {deletePopUp.name}?
        </div>
        <p className='delete-popup-description'>{deletePopUp.description}</p>
        <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
          <Button variant='outlined' size='large' color='secondary' onClick={(e) => handleClose()}>
            Cancel
          </Button>
          <Button
            variant='contained'
            size='large'
            color='primary'
            onClick={(e) => onDeleteClick(e)}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={deletePopUp.status} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default DeletePopupModel;
